import {
  Grid,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  Button,
  Container,
  Box,
  Paper,
} from "@mui/material";

import routes from "routes";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// Author page sections

import DefaultFooter from "examples/Footers/DefaultFooter";
import footerRoutes from "footer.routes";
export default function FormularioDenunciaPage() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "/afiliate",
          label: "Afiliate",
          color: "info",
        }}
        transparent
        light
      />
      <MKBox bgColor="white">
        <MKBox
          minHeight="25rem"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.8),
                rgba(gradients.dark.state, 0.8)
              )}, url("https://img.freepik.com/foto-gratis/vista-cosechada-persona-que-llena-formulario-solicitud_1262-2272.jpg")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        />
        <>
          <Container maxWidth="lg" sx={{ py: 6 }}>
            {/* TÍTULO */}
            <Typography variant="h4" fontWeight="bold" mb={1}>
              FORMULARIO DE DENUNCIA LABORAL
            </Typography>

            <Box
              sx={{
                width: "100%",
                height: "3px",
                backgroundColor: "#2196f3",
                mb: 4,
              }}
            />

            <Paper sx={{ p: 4, borderRadius: 3 }}>
              <Typography variant="body1" sx={{ mb: 3 }}>
                Llená el siguiente formulario para que podamos ayudarte a regularizar tu situación
                laboral. Todos los datos son confidenciales.
              </Typography>

              <Grid container spacing={3}>
                {/* ===========================
            DATOS PERSONALES
        ============================ */}
                <Grid item xs={12}>
                  <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                    Datos personales
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Nombre" variant="outlined" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Apellido" variant="outlined" />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Teléfono personal" variant="outlined" />
                </Grid>

                {/* ===========================
            INFORMACIÓN DEL EMPLEO
        ============================ */}
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                    Información del empleo
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Lugar de trabajo (nombre de la panadería)"
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField fullWidth label="Dirección del lugar de trabajo" variant="outlined" />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Teléfono del empleador / encargado"
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Horario habitual de trabajo"
                    placeholder="Ej: Lunes a sábados, 6 a 14 hs"
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Remuneración percibida (monto)" variant="outlined" />
                </Grid>

                {/* ===========================
            BENEFICIOS Y DERECHOS
        ============================ */}
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                    ¿Recibís alguno de los siguientes derechos?
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel control={<Checkbox />} label="Kilo de pan diario" />
                  <FormControlLabel control={<Checkbox />} label="Ropa / uniforme de trabajo" />
                  <FormControlLabel control={<Checkbox />} label="Obra social" />
                  <FormControlLabel
                    control={<Checkbox />}
                    label="Seguro de riesgos del trabajo (ART)"
                  />
                </Grid>

                {/* ===========================
            INFORMACIÓN ADICIONAL
        ============================ */}
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                    Información adicional importante
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Describí las irregularidades o problemas laborales"
                    placeholder="Ejemplo: No me pagan feriados, no me registran, trabajo más horas sin paga, maltrato, amenazas, etc."
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="¿Desde cuándo sucede esta situación?"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="¿Hay otros trabajadores en la misma situación?"
                  />
                </Grid>

                {/* ===========================
            CONFIDENCIALIDAD
        ============================ */}
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                    Aviso de Confidencialidad
                  </Typography>

                  <Typography variant="body2" sx={{ color: "gray", mb: 2 }}>
                    Esta denuncia es <strong>confidencial</strong>. No revelaremos tus datos
                    personales bajo ninguna circunstancia. Es posible que nos comuniquemos con vos
                    únicamente para obtener información adicional que nos ayude a intervenir en tu
                    caso.
                  </Typography>
                </Grid>

                {/* ===========================
            BOTÓN DE ENVÍO
        ============================ */}
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ py: 1.4, fontSize: "1rem", color: "#FFFFFF" }}
                  >
                    Enviar denuncia
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Container>
        </>

        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </MKBox>
    </>
  );
}
